import { AMBIENTE } from "../../environments";

// Api Backend
let API = "";
const prod = "PROD";
const test = "TEST";
const dev = "DEV";

console.log("AMBIENTE" + AMBIENTE);
switch (AMBIENTE) {
  case prod:
    API = "https://buscadoractos.sic.gov.co/";
    break;
  case test:
    //API = 'https://public.test.sic.nuvu.cc/';
    API = "https://relatoria.sic.gov.co/";
    //API = 'http://es.test.sic.nuvu.cc/'
    break;
  case dev:
    API = "https://dev.sic.nuvu.cc/";
    // API = 'https://admin.es.dev.sic.nuvu.cc/';
    break;
  default:
    //API = 'https://public.int.sic.nuvu.cc/';
    API = "https://relatoria.sic.gov.co/";
    break;
}

// export const API_FILTERS = API + "sic-actos-0001/_search?pretty";
export const API_FILTERS = API + 'sic-actos/_search?pretty';
// export const API_COUNT = API + "sic-actos-0001/_count";
export const API_COUNT = API + 'sic-actos/_count';

// Constantes Actos

export const DEPENDENCIA_ACTO_KEY = "acto.informacion_acto.dependencia.keyword";

export const NUMERO_ACTO_KEY = "acto.informacion_acto.numero.keyword";
export const NUMERO_RADICACION_KEY =
  "acto.informacion_acto.numero_radicacion.keyword";

export const ANO_RADICACION_KEY =
  "acto.informacion_acto.ano_radicacion.keyword";

export const ROL_KEY = "acto.partes.rol.keyword";
export const TIPO_DOC_1_KEY = "acto.partes.tipo_documento_valor.keyword";
export const TIPO_DOC_2_KEY =
  "acto.partes.tipo_documento_representante_valor.keyword";
export const NUMERO_DOC_1_KEY = "acto.partes.numero_documento.keyword";
export const NUMERO_DOC_2_KEY =
  "acto.partes.numero_documento_representante.keyword";

export const NOMBRE_REPRESENTANTE_KEY = "acto.partes.nombre_representante";
export const NOMBRE_KEY = "acto.partes.nombre";

export const END_DATE_KEY = "acto.informacion_acto.fecha";
export const START_DATE_KEY = "acto.informacion_acto.fecha";

export const SUBCLASE_NAME_KEY = "acto.subclases.nombre.keyword";
export const TIPO_ACTO_KEY = "acto.informacion_acto.tipo.keyword";
export const CLASE_NAME_KEY = "acto.subclases.nombre_clase.keyword";

export const SUBCLASE_NAME_KEY_QUERY = "acto.subclases_filtro.nombre.keyword";
export const TIPO_ACTO_KEY_QUERY =
  "acto.subclases_filtro.tipo_acto_clase.keyword";
export const CLASE_NAME_KEY_QUERY =
  "acto.subclases_filtro.nombre_clase.keyword";

// LV Values Types and Search Filter Types
export const NUMERO_EXPEDIENTE_KEY = "informacion.numero_expediente";
export const ANO_EXPEDIENTE_KEY = "informacion.ano_radicacion";

export const PROCESS_TYPE_KEY = "informacion.tipo_proceso.keyword";
export const PROVIDENCE_TYPE_KEY = "informacion.tipo_providencia.keyword";

export const CATEGORY_KEY = "tesauro.categoria.nombre.keyword";
export const DESCRIPTOR_KEY = "tesauro.descriptor.nombre.keyword";
export const RESTRICTION_KEY = "tesauro.restrictor.nombre.keyword";

export const CATEGORY_KEY_QUERY = "tesauro_filtro.categoria";
export const DESCRIPTOR_KEY_QUERY = "tesauro_filtro.descriptor";
export const RESTRICTION_KEY_QUERY = "tesauro_filtro.restrictor";

export const NORM_KEY = "archivos.entidades.texto";

//export const ROL_KEY = 'partes.rol.keyword';
export const ID_KEY = "partes.tipo_id.keyword";
export const ID_NUMBER_KEY = "partes.numero_doc.keyword";
export const NAME_KEY = "partes.nombre";

// export const END_DATE_KEY = 'informacion.fecha_providencia';
// export const START_DATE_KEY = 'informacion.fecha_providencia';

export const PUB_DATE_KEY = "informacion.fecha_publicada";

export const ID_REL_KEY = "id_relatoria.keyword";

export const KEYS_MAP = {
  // TO DO borrar
  processType: PROCESS_TYPE_KEY,
  providenceType: PROVIDENCE_TYPE_KEY,
  norms: NORM_KEY,
  category: CATEGORY_KEY,
  descriptors: DESCRIPTOR_KEY,
  restrictions: RESTRICTION_KEY,

  idType: TIPO_DOC_1_KEY,
  idNumber: NUMERO_DOC_1_KEY,
  numero2: NUMERO_DOC_2_KEY,
  name: NOMBRE_KEY,
  numero: NUMERO_DOC_1_KEY,
  expediente: NUMERO_RADICACION_KEY,
  numActo: NUMERO_ACTO_KEY,
  tipoActo: TIPO_ACTO_KEY,
  dependencia: DEPENDENCIA_ACTO_KEY,
  rol: ROL_KEY,
  clase: CLASE_NAME_KEY,
  subclase: SUBCLASE_NAME_KEY,
  anoExpediente: ANO_RADICACION_KEY,
};

export const KEYS_BUSQUEDA_EXPEDIENTE = {
  anio: ANO_RADICACION_KEY,
  expediente: NUMERO_RADICACION_KEY,
};

export const RESULTS_PER_PAGE = 5;

export const SORT_OPTIONS = [
  {
    label: "Ascendente",
    value: `${START_DATE_KEY}&asc`,
  },
  {
    label: "Descendente",
    value: `${START_DATE_KEY}&desc`,
  },
];

let URL_VISOR = "http://localhost:9000/";

switch (AMBIENTE) {
  case prod:
    URL_VISOR = "https://gestoractos.sic.gov.co/";
    //URL_VISOR = 'http://localhost:8080/';
    break;
  case test:
    URL_VISOR = "https://test.sic.nuvu.cc/";
    break;
  case dev:
    URL_VISOR = "https://gestor.dev.sic.nuvu.cc/";
    //URL_VISOR = 'http://localhost:8080/';
    break;
  default:
    URL_VISOR = "http://sso.test.sic.nuvu.cc/";
    break;
}

export const URL_VISOR_RELATORIAS = URL_VISOR;

let SIGN_URL_AUX = "https://public.int.sic.nuvu.cc/get-url-upload/";
let SIGN_TRANSCRIPTION_URL_AUX =
  "https://public.test.sic.nuvu.cc/get-signed-url/";
let UPLOAD_URL_AUX = "s3://int-relatorias-document/Document/";
let DOWNLOAD_URL_AUX = "s3://int-relatorias-transcription/Transcription/";

switch (AMBIENTE) {
  case prod:
    SIGN_URL_AUX =
      "https://m0s03uyzg3.execute-api.us-east-1.amazonaws.com/prod/get-url-upload/";
    SIGN_TRANSCRIPTION_URL_AUX =
      "https://m0s03uyzg3.execute-api.us-east-1.amazonaws.com/prod/get-signed-url/";
    UPLOAD_URL_AUX = "s3://prod-relatorias-document/Document/";
    DOWNLOAD_URL_AUX = "s3://prod-relatorias-transcription/Transcription/";
    break;
  case test:
    // env dev
    SIGN_URL_AUX =
      "https://pl4d5ajf0d.execute-api.us-east-1.amazonaws.com/dev/sign-url-upload/";
    SIGN_TRANSCRIPTION_URL_AUX =
      "https://rh04uuvlu6.execute-api.us-east-1.amazonaws.com/dev/sign-url-download/";
    UPLOAD_URL_AUX = "s3://baa-dev-actos-document/Document/";
    DOWNLOAD_URL_AUX = "s3://baa-dev-actos-transcription/Transcription/";
    break;
  case dev:
    SIGN_URL_AUX =
      "https://m0s03uyzg3.execute-api.us-east-1.amazonaws.com/prod/get-url-upload/";
    SIGN_TRANSCRIPTION_URL_AUX =
      "https://m0s03uyzg3.execute-api.us-east-1.amazonaws.com/prod/get-signed-url/";
    UPLOAD_URL_AUX = "s3://prod-relatorias-document/Document/";
    DOWNLOAD_URL_AUX = "s3://prod-relatorias-transcription/Transcription/";
    break;
  default:
    break;
}

export const SIGN_URL = SIGN_URL_AUX;
export const SIGN_TRANSCRIPTION_URL = SIGN_TRANSCRIPTION_URL_AUX;
export const UPLOAD_URL = UPLOAD_URL_AUX;
export const DOWNLOAD_URL = DOWNLOAD_URL_AUX;

let CAPTCHA_API_KEY = "6Ldm6o8aAAAAANaK1UlUNX27tYB3bPBg1AG1NIfx";

switch (AMBIENTE) {
  case prod:
    CAPTCHA_API_KEY = "6LfVxd8ZAAAAALrGUIor5me9v5tmQ0VZRqOnROji";
    break;
  case test:
    CAPTCHA_API_KEY = "6LcDVYgcAAAAANx5vnxuqr9HFle6260m6nC3HoNw";
    break;
  case dev:
    CAPTCHA_API_KEY = "6LcDVYgcAAAAANx5vnxuqr9HFle6260m6nC3HoNw";
    break;
  default:
    CAPTCHA_API_KEY = "6Ldm6o8aAAAAANaK1UlUNX27tYB3bPBg1AG1NIfx";
    break;
}

export const CAPTCHA_KEY = CAPTCHA_API_KEY;

export const CAPTCHA_KEY_V3 = "6Le8WB8eAAAAAIYbdoN61b-Ueul50rRRDManuugm";
